import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

const PageHeader = ({ title, rightAction, showBack = false, showLogo = false, animateEntry = false, onBack, logoLayoutId, ...props }) => {
  const navigate = useNavigate();
  const isGeoFont = props['font-geo'];

  // Animation variants
  const logoVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: "easeOut" } }
  };

  const titleVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: { opacity: 1, x: 0, transition: { delay: 0.2, duration: 0.5 } }
  };

  const actionVariants = {
    hidden: { opacity: 0, x: 10 },
    visible: { opacity: 1, x: 0, transition: { delay: 0.4, duration: 0.5 } }
  };

  return (
    <header className="py-4 flex items-center justify-between mt-2 md:mt-0 w-full min-h-[60px]">
      <div className="flex items-center gap-1 ml-2 sm:ml-0">
        {showBack && (
          <button
            onClick={onBack || (() => navigate(-1))}
            className="p-2 -ml-2 rounded-full hover:bg-[var(--color-surface)] transition-colors text-[var(--color-text)]"
            aria-label="Go back"
          >
            <ArrowLeft size={24} />
          </button>
        )}
        
        {showLogo && (
          <motion.div
            layoutId={logoLayoutId}
            initial={animateEntry ? "hidden" : "visible"}
            animate="visible"
            variants={logoVariants}
            className="relative flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 mr-1 sm:mr-1.5"
          >
             <img 
              src="/outflow-logo.svg" 
              alt="Outflow Logo" 
              className="w-full h-full object-contain"
            />
          </motion.div>
        )}

        <motion.h1 
          initial={animateEntry ? "hidden" : "visible"}
          animate="visible"
          variants={titleVariants}
          className={`tracking-tight text-[var(--color-text)] ${isGeoFont ? 'text-2xl sm:text-4xl font-geo' : 'text-xl sm:text-3xl font-bold'}`}
        >
          {title}
        </motion.h1>
      </div>
      
      {rightAction && (
        <motion.div
           initial={animateEntry ? "hidden" : "visible"}
           animate="visible"
           variants={actionVariants}
        >
          {rightAction}
        </motion.div>
      )}
    </header>
  );
};

export default PageHeader;
